import { merge } from 'lodash';

/**
 * @param {SF.User} user the staff user with their calendars and privileges
 * @returns {list} all unlocked calendars the user has access to among their own calendar and those the user manages
 */
const getAllUnlockedCalendars = user => user.isCalendarLocked() ?
  user.getUnlockedCalendars() :
  [].concat(
    [{
      id: user.scheduleId,
      owner: {
        id: user.partyId,
        name: user.name
      }
    }],
    user.getUnlockedCalendars());

/**
 * @param {SF.User} user the staff user with their calendars and privileges
 * @param {boolean} calendarLockingEnabled whether calendar locking is enabled for the tenant
 * @returns {object} For calendar managers with locked calendars, returns a schedule if there is only
 * one possible choice. This can either be your own schedule if your calendar is unlocked
 * and all the calendars you manage are locked, or another user's calendar if yours is locked.
 *
 * If there are 0 or more than 1 schedules matching this criteria, none is returned.
 */
export const onlyPossibleScheduleForManager = (user, calendarLockingEnabled) => {
  if (!user || !user.hasPriv('CALENDARMANAGER') || !calendarLockingEnabled) {
    return null;
  }
  const unlockedCalendars = getAllUnlockedCalendars(user);
  if (unlockedCalendars.length !== 1) return null;

  return unlockedCalendars[0];
};

merge(global.SF, { calendar: { onlyPossibleScheduleForManager }});
